//# sourceMappingURL=my-calendar-view-changed.interface.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/mydatepicker/dist/interfaces/my-calendar-view-changed.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-calendar-view-changed.interface.js
// module chunks = 4